// extracted by mini-css-extract-plugin
export default {"cart-header":"CartHeader_cart-header__sVkxy","fade-in":"CartHeader_fade-in__0lDjx","dropdown":"CartHeader_dropdown__afwr8"};